import { Badge } from '../../../shared/Badge/Badge';
import { BROADCAST_STATUS_CONFIG } from '../../campaigns/components/CampaignsTable/CalendarView/helpers';

export const StatusBadge = ({ status }) => {
  const config = BROADCAST_STATUS_CONFIG[status];
  if (!config) return null;

  return (
    <Badge
      variant="rounded"
      style={{
        backgroundColor: config.color,
        color: 'white',
        border: 'none',
      }}
    >
      {config.label}
    </Badge>
  );
};
